var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrderMobileNav = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63428 19.4801H15.3468V17.4828H5.63428V19.4801ZM5.63428 14.3524H15.3468V12.3551H5.63428V14.3524ZM2.80157 25C2.1479 25 1.58624 24.7652 1.1166 24.2955C0.646939 23.8259 0.412109 23.2642 0.412109 22.6105V2.4065C0.412109 1.74814 0.646939 1.18246 1.1166 0.709466C1.58624 0.236489 2.1479 0 2.80157 0H13.7246L20.586 6.86144V22.6105C20.586 23.2642 20.3495 23.8259 19.8765 24.2955C19.4035 24.7652 18.8379 25 18.1795 25H2.80157ZM12.4787 8.01684H18.1795L12.4787 2.4065V8.01684Z",
    fill: "#9DA0A7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrderMobileNav);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/order_mobile_nav.4126399bd4e7a10540bee3ecbff7ab98.svg";